<template>
    <div id="Statistics">
        <Head />
        <div class="hotspot clear">
            <Nav ms="/Bgreview" />
            <div class="standard">
                <div class="title">
                    <i></i>
                    创新成果评审标准
                </div>
                <el-collapse-transition>
                    <div v-show="show3">
                        <el-table
                            border
                            :data="tableData1"
                            stripe
                            style="width: 100%;margin-bottom: 20px"
                            :header-cell-style="tableBG"
                            :row-style="{ height: '0.4rem' }"
                        >
                            <el-table-column
                                prop="No"
                                label="序号"
                                header-align="center"
                                align="center"
                                width="50"
                            ></el-table-column>
                            <el-table-column
                                prop="Title"
                                label="评审内容"
                                width="90"
                                header-align="center"
                                align="center"
                            ></el-table-column>
                            <el-table-column
                                prop="Score"
                                label="分值"
                                width="60"
                                header-align="center"
                                align="center"
                            ></el-table-column>
                            <el-table-column
                                prop="FirstLevel"
                                label="一等"
                                width="200"
                                header-align="center"
                                align="center"
                            ></el-table-column>
                            <el-table-column
                                prop="SecondLevel"
                                label="二等"
                                width="207"
                                header-align="center"
                                align="center"
                            ></el-table-column>
                            <el-table-column
                                prop="ThirdLevel"
                                label="三等"
                                width="205"
                                header-align="center"
                                align="center"
                            ></el-table-column>
                            <el-table-column
                                prop="PassLevel"
                                label="淘汰类"
                                header-align="center"
                                align="center"
                                width="180"
                            ></el-table-column>
                        </el-table>
                    </div>
                </el-collapse-transition>
                <div class="button">
                    <el-button @click="show3 = !show3">{{ show3 ? "收起" : "展开" }}</el-button>
                </div>
            </div>
            <div v-if="tabClick == 0" class="H-right">
                <div class="H-header"></div>
                <div class="t_main">
                    <div class="t_main_select">
                        <!-- <select v-model="year" @change="getStatus">
                    <option value="2022">2022</option>
                <option value="2021">2021</option>
                <option value="2020">2020</option>
              </select> -->
                        <el-date-picker
                            v-model="year"
                            type="year"
                            @change="getStatus"
                            :default-value="value"
                            value-format="yyyy"
                            :picker-options="pickerOptions"
                            placeholder="请选择"
                            :clearable="false"
                        >
                        </el-date-picker>
                        <select v-model="Status" @change="getStatus">
                            <option value="0">未评审</option>
                            <option value="1">已评审</option>
                        </select>
                    </div>
                    <!-- <div class="table">
            <div class="list" v-for="(item,index) in tableData" :key="index">
              <div class="btn btnmini" @click="tabchange(1,item)">{{item.Status==0?'评审':'查看'}}</div>
            
              <div class="l-info">
                <div class="l-info-name">
                  <span>申请报告名称：</span>
                  <span>{{item.Title}}</span>
                 
                </div>
                <div class="l-info-bottom">
                  <div class="l-info-left">
                    <div class="l-info-time">
                      <span>申报时间：{{item.DeclarTime}}</span>
                    </div>
                    <div class="l-info-text">
                      
                      <span>{{item.ParentClassname}}</span>
                      <span>{{item.Classname}}</span>
                    </div>
                  </div>
                  <div class="l-info-result">
                    <p v-if="item.FinTime">评审时间：{{item.FinTime}}</p>
                    <p style="margin-top:.1rem">
                      {{item.Status==0?'待评审':'评审完成：'}}
                      <span
                        v-if="item.Status!=0"
                        style="color:red"
                      >{{item.total}}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>-->

                    <el-table
                        border
                        :header-cell-style="{ 'background-color': '#001743', color: '#fff', height: '0.5rem' }"
                        :stripe="true"
                        :data="tableData"
                        style="width: 100%;max-height:95%"
                        :row-style="{ height: '0.4rem' }"
                    >
                        <el-table-column
                            prop="序号"
                            type="index"
                            header-align="center"
                            align="center"
                        ></el-table-column>
                        <el-table-column
                            prop="Title"
                            label="成果名称"
                            header-align="center"
                            align="center"
                        ></el-table-column>
                        <el-table-column
                            prop="companyname"
                            label="完成单位"
                            header-align="center"
                            align="center"
                        ></el-table-column>
                        <el-table-column label="状态" header-align="center" align="center" width="100">
                            <template slot-scope="scope">
                                <p>{{ scope.row.Status == 0 ? "待评审" : "评审完成" }}</p>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="total"
                            label="评审分数"
                            v-if="Status == 1"
                            header-align="center"
                            align="center"
                            width="100"
                        ></el-table-column>
                        <el-table-column
                            prop="FinTime"
                            label="评审时间"
                            v-if="Status == 1"
                            header-align="center"
                            width="100"
                            align="center"
                        ></el-table-column>
                        <el-table-column label="操作" width="100" header-align="center" align="center">
                            <template slot-scope="scope">
                                <el-button type="primary" size="medium" @click="tabchange(1, scope.row)">{{
                                    scope.row.Status == 0 ? "评审" : "查看"
                                }}</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                        style="text-align: right;height: 0.45rem;"
                        v-if="tableData.length > 0"
                        @current-change="CurrentChange1"
                        @size-change="handleSizeChange1"
                        :current-page="Page1"
                        :page-size="PageSize1"
                        :page-sizes="[10, 20, 30]"
                        layout="total,sizes, prev, pager, next, jumper"
                        :total="total"
                    ></el-pagination>
                </div>
            </div>
            <div v-if="tabClick == 1" class="H-right">
                <div class="btn btnmini" style="margin-bottom: 0.2rem;" @click="tabchange(0)">返回</div>
                <!-- <div class="info">
          <div  class="clear">
            <span>成果名称：</span>
            <div style="font-weight:bold;">{{user.Title}}</div>
          </div>
          <div class="clear">
            <span></span>
            <div class="upload" @click="tabchange(2,0,2)">
              成果主报告
            </div>
          </div>
        </div>-->
                <!-- <div class="info">
          <div>成果名称：<b>{{user.Title}}</b></div>
          <div>成果报告申请表: <span class="span1" >预览</span></div>
          <div>成果主报告: <span class="span2" >预览</span></div>
          <div>成果附件: <span class="span3" >预览</span></div>
        </div>-->
                <div class="info">
                    <div>
                        成果名称：
                        <b>{{ user.Title }}</b>
                    </div>
                    <!-- <div class="left-button">
            成果报告申请表:
            <div class="lastBtn">
              <el-button type="primary" style="width:1rem" @click="tabchange(2,0,1)">预览</el-button>
              <el-button
                style="width:1rem;background: rgb(243, 37, 47);color:#fff"
                @click="dowCg(1)"
              >下载</el-button>
            </div>
          </div>-->
                    <div class="left-button">
                        成果主报告:
                        <div class="sendBtn">
                            <el-button type="primary" style="width:1rem" @click="tabchange(2, 0, 2)">预览</el-button>
                            <!-- <el-button
                style="width:1rem;background: rgb(243, 37, 47);color:#fff"
                @click="dowCg(2)"
              >下载</el-button>-->
                        </div>
                    </div>
                    <div>
                        成果附件:
                        <el-button
                            style="width:1rem;background: rgb(243, 37, 47);color:#fff;margin-left:1.04rem"
                            @click="tabchange(2, 0, 3)"
                            >{{ fj ? "下载" : "无" }}</el-button
                        >
                        <!-- <span>无</span> -->
                    </div>
                    <div class="jieguo">
                        <i></i>
                        <div class="jieguospan">查重结果:</div>
                        <div class="repetition" v-if="baogao.wordRepetitionRate">{{ percentage }}%相似</div>
                        <!-- <a :href="baogaoUrl||'javascript:;'" target="_blank" style="color:#2D65D2;">点击查看</a> -->
                        <a @click="tabchange(2, 0, 4)" style="color:#2D65D2;">点击查看</a>
                    </div>
                </div>
                <div class="title">
                    <input
                        type="text"
                        :disabled="!val && reviewform.Status == 1"
                        v-model="reviewform.score1"
                        placeholder="请输入您的评审分数"
                        @keyup="reviewform.score1 = screen(reviewform.score1, 30)"
                    />
                    <!-- <p class="score" v-else>{{reviewform.score1}}{{val}}</p> -->
                    <div>
                        <div></div>
                        <span>创新性（30分）</span>
                    </div>

                    <!-- <p class="warning">请输入正整数</p> -->
                </div>

                <div class="title">
                    <input
                        type="text"
                        :disabled="!val && reviewform.Status == 1"
                        v-model="reviewform.score2"
                        placeholder="请输入您的评审分数"
                        @keyup="reviewform.score2 = screen(reviewform.score2, 15)"
                    />
                    <!-- <p class="score" v-else>{{reviewform.score2}}</p> -->
                    <div>
                        <div></div>
                        <span>科学性（15分）</span>
                    </div>

                    <!-- <p class="warning">请输入正整数</p> -->
                </div>
                <div class="title">
                    <input
                        type="text"
                        :disabled="!val && reviewform.Status == 1"
                        v-model="reviewform.score3"
                        placeholder="请输入您的评审分数"
                        @keyup="reviewform.score3 = screen(reviewform.score3, 10)"
                    />

                    <!-- <p class="score" v-else>{{reviewform.score3}}</p> -->
                    <div>
                        <div></div>
                        <span>实践性（10分）</span>
                    </div>
                    <!-- <p class="warning">请输入正整数</p> -->
                </div>
                <div class="title" :class="!val ? 'flex' : ''">
                    <input
                        type="text"
                        :disabled="!val && reviewform.Status == 1"
                        v-model="reviewform.score4"
                        placeholder="请输入您的评审分数"
                        @keyup="reviewform.score4 = screen(reviewform.score4, 15)"
                    />
                    <!-- <p class="score" v-else>{{reviewform.score4}}</p> -->
                    <div>
                        <div></div>
                        <span>效益性（15分）</span>
                    </div>
                    <!-- <p class="warning">请输入正整数</p> -->
                </div>
                <div class="title" :class="!val ? 'flex' : ''">
                    <input
                        type="text"
                        :disabled="!val && reviewform.Status == 1"
                        v-model="reviewform.score5"
                        placeholder="请输入您的评审分数"
                        @keyup="reviewform.score5 = screen(reviewform.score5, 15)"
                    />
                    <!-- <p class="score" v-else>{{reviewform.score5}}</p> -->
                    <div>
                        <div></div>
                        <span>示范性（15分）</span>
                    </div>
                    <!-- <p class="warning">请输入正整数</p> -->
                </div>
                <div class="title" :class="!val ? 'flex' : ''">
                    <input
                        type="text"
                        :disabled="!val && reviewform.Status == 1"
                        v-model="reviewform.score6"
                        placeholder="请输入您的评审分数"
                        @keyup="reviewform.score6 = screen(reviewform.score6, 5)"
                    />
                    <!-- <p class="score" v-else>{{reviewform.score6}}</p> -->
                    <div>
                        <div></div>
                        <span>规范性-材料格式（5分）</span>
                    </div>
                    <!-- <p class="warning">请输入正整数</p> -->
                </div>
                <div class="title" :class="!val ? 'flex' : ''">
                    <input
                        type="text"
                        :disabled="!val && reviewform.Status == 1"
                        v-model="reviewform.score7"
                        placeholder="请输入您的评审分数"
                        @keyup="reviewform.score7 = screen(reviewform.score7, 10)"
                    />
                    <!-- <p class="score" v-else>{{reviewform.score7}}</p> -->
                    <div>
                        <div></div>
                        <span>规范性-文字描述（10分）</span>
                    </div>
                    <!-- <p class="warning">请输入正整数</p> -->
                </div>
                <div class="title" :class="!val ? 'flex' : ''">
                    <!-- <input type="number" v-model="reviewform.sum" placeholder="请输入您的评审分数" readonly="readonly"> -->
                    <div>
                        <div></div>
                        <span>累计得分</span>
                        <p style="margin-left:3rem">{{ value1 }}</p>
                    </div>
                </div>
                <div class="yijian">
                    <div>
                        <div></div>
                        <span>评审意见：</span>
                    </div>
                    <textarea
                        :disabled="!val && reviewform.Status == 1"
                        v-model="reviewform.comment"
                        name
                        id
                        cols="30"
                        rows="10"
                    ></textarea>
                </div>
                <div class="sub">
                    <div class="btn" @click="updateinfo(reviewform.Status)" v-if="val || reviewform.Status == 0">
                        {{ reviewform.Status == 0 ? "提交评审结果" : "确认修改" }}
                    </div>
                </div>
            </div>
            <div v-show="tabClick == 2" class="H-right">
                <div class="btn btnmini" style="margin-bottom: 0.2rem;position:fixed;z-index:30" @click="tabchange(1)">
                    返回
                </div>
                <Preview v-if="lookStatus == 1" :yulan="yulan" />
                <FullPreview v-if="lookStatus == 2" :zbg="user.ReportID" />
                <!-- <div  v-show="lookStatus==2"  v-html="showall">成果主报告</div> -->
                <iframe
                    v-if="lookStatus == 4"
                    width="1000"
                    style="width:100%"
                    height="1000"
                    frameborder="0"
                    :src="baogaoUrl"
                ></iframe>
            </div>
        </div>
        <Foot />
    </div>
</template>
<script>
import Head from "../../components/BackHead";
import Foot from "../../components/Foot";
import Nav from "../../components/BackNav";
import Preview from "@/views/Declare/Preview";
import FullPreview from "../Declare/FullPreview";
// 过渡动画
// fade/zoom 等
import "element-ui/lib/theme-chalk/base.css";
// collapse 展开折叠
import CollapseTransition from "element-ui/lib/transitions/collapse-transition";
import Vue from "vue";
Vue.component(CollapseTransition.name, CollapseTransition);

export default {
    name: "Expert",
    data() {
        return {
            user: {},
            tabClick: 0,
            total: 1,
            date: "",
            // status:'0',
            tableData: [],
            Page1: 1,
            value: 1,
            PageSize1: 10,
            isPopup: false,
            allstatus: [],
            statusnum: "",
            reportid: "",
            contentInfo: [],
            reviewid: "",
            yulan: "",
            lookStatus: "",
            cgzbg: "",
            reviewform: {
                ID: "1",
                Status: "",
                score1: "",
                score2: "",
                score3: "",
                score4: "",
                score5: "",
                score6: "",
                score7: "",
                total: "",
                comment: "",
            },
            // zbgdata: [], //主报告数据
            showall: "",
            fj: "",
            sbb: "",
            cgzbg1: "",
            tableData1: [],
            show3: false,
            baogaoUrl: "",
            baogao: "",
            percentage: "",
            Status: 0,
            test: [],
            val: "",
            year: new Date().getFullYear().toString(), //element组件默认值为String，传数字会读取不出来
            pickerOptions: {
                // 禁选今日之后的时间,time是当前时间选择器的显示内容
                disabledDate(time) {
                    const date = new Date(); //获取当前时间信息
                    const year = date.getFullYear(); //获取当前年份
                    const timeYear = time.getFullYear(); //获取时间选择器的所有年份
                    // 2020之前与今年之后的全部禁用
                    return timeYear < 2020 ? timeYear < 2020 : timeYear > year;
                },
            },
        };
    },
    created() {
        this.getdata();
        //this.getteacher();
        this.getReviewstandard();
        this.getSwitch();
    },
    methods: {
        getSwitch() {
            this.$axios.post("log/systemReview?token=" + sessionStorage.getItem("token")).then((res) => {
                if (res.data.code == 10000) {
                    this.val = res.data.data.nums == 0 ? true : false;
                }
            });
        },
        screen(num, max) {
            var reg = /[^\d]/g;
            var newnum = num.replace(reg, "");
            console.log(newnum);
            if (newnum > max) {
                newnum = max;
                console.log(max);
            }
            return newnum;
        },
        getStatus() {
            // console.log(this.Status, 66666666666);
            this.Page1 = 1;
            this.PageSize1 = 10;
            this.getdata();
        },
        getReviewstandard() {
            this.$axios.post("reviewstandard/index?token=" + sessionStorage.getItem("token")).then((res) => {
                if (res.data.code == 10000) {
                    // console.log(res.data.data);
                    this.tableData1 = res.data.data;
                    // this.centerDialogVisible = true;
                } else {
                    this.$message({
                        type: "warning",
                        message: res.data.msg,
                    });
                }
            });
        },
        getBaogao() {
            var that = this;
            // console.log(this.user);
            that.$axios
                .post(
                    "check/ccresult?token=" + sessionStorage.getItem("token"),
                    that.$qs.stringify({
                        ReportID: this.user.ReportID,
                    })
                )
                .then((res) => {
                    if (res.data.code == 10000) {
                        console.log(res, "报告");
                        if (res.data.data[0]) {
                            this.baogao = res.data.data[0];
                            this.baogaoUrl = res.data.data[0].Result;
                            this.percentage = (res.data.data[0].wordRepetitionRate * 100).toFixed(2);
                            // console.log(this.percentage);
                        }
                    } else {
                        this.$message({
                            message: res.data.msg,
                            type: "warning",
                        });
                    }
                });
        },
        // 表头背景色

        tableBG(row) {
            if (row) {
                if (row.columnIndex == 3) {
                    return "background:#06a814;color:#fff";
                }
                if (row.columnIndex == 4) {
                    return "background:#08599a;color:#fff";
                }
                if (row.columnIndex == 5) {
                    return "background:#be3d1d;color:#fff";
                }
                if (row.columnIndex == 6) {
                    return "background:#de0637;color:#fff";
                }
                return "background:#001743;color:#fff";
            }
        },
        Popups() {
            this.isPopup = !this.isPopup;
        },
        getdata(status) {
            // console.log(this.lx);
            var that = this;

            that.$axios
                .post(
                    "review/ReviewLists?token=" + sessionStorage.getItem("token"),
                    // "Review/selectreview?token=" + sessionStorage.getItem("token"),
                    that.$qs.stringify({
                        page: this.Page1,
                        num: this.PageSize1,
                        year: this.year,
                        status: status || this.Status,
                    })
                )
                .then((res) => {
                    if (res.data.code == 10000) {
                        // console.log(res.data.data, 6666);
                        // var list = res.data.data;

                        // var st = (this.Page1 - 1) * this.PageSize1;
                        // this.tableData = list.slice(
                        //   this.Page1 == 1 ? 0 : st,
                        //   this.PageSize1 * this.Page1
                        // );
                        this.tableData = res.data.data;

                        this.total = res.data.total_num * 1;
                    } else {
                        this.$message({
                            message: res.data.msg,
                            type: "warning",
                        });
                    }
                });
        },
        updateinfo(Status) {
            var that = this;
            this.$confirm("确认提交评审结果, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.reviewform.total =
                        this.reviewform.score1 * 1 +
                        this.reviewform.score2 * 1 +
                        this.reviewform.score3 * 1 +
                        this.reviewform.score4 * 1 +
                        this.reviewform.score5 * 1 +
                        this.reviewform.score6 * 1 +
                        this.reviewform.score7 * 1;
                    // console.log(Status);
                    // console.log(that.reviewform.ReportID);
                    if (Status == 0) {
                        this.reviewform.Status = 1;

                        that.$axios
                            .post(
                                "review/update?token=" + sessionStorage.getItem("token"),
                                that.$qs.stringify(this.reviewform)
                            )
                            .then((res) => {
                                if (res.data.code == 10000) {
                                    // console.log(res.data.msg);
                                    that.$message({
                                        message: res.data.msg,
                                        type: "success",
                                    });
                                    that.statusUP(that.reviewform.ReportID);
                                    that.getdata(0);
                                    that.tabchange(0);
                                } else {
                                    console.log(res.data);
                                    this.$message({
                                        message: res.data.msg,
                                        type: "warning",
                                    });
                                }
                            });
                    } else {
                        that.$axios
                            .post(
                                "review/updatescores?token=" + sessionStorage.getItem("token"),
                                that.$qs.stringify(that.reviewform)
                            )
                            .then((res) => {
                                if (res.data.code == 10000) {
                                    that.$message({
                                        message: res.data.msg,
                                        type: "success",
                                    });
                                } else {
                                    that.$message({
                                        message: res.data.msg,
                                        type: "warning",
                                    });
                                }
                            });
                    }
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                });
        },
        statusUP(id) {
            var that = this;
            that.$axios
                .post(
                    "report/updatestatus?token=" + sessionStorage.getItem("token"),
                    that.$qs.stringify({
                        ID: id,
                        Status: 5,
                    })
                )
                .then((res) => {
                    if (res.data.code == 10000) {
                        this.tabchange(0);
                        // this.$message({
                        //   message: res.data.msg,
                        //   type: "warning"
                        // });
                    } else {
                        this.$message({
                            message: res.data.msg,
                            type: "warning",
                        });
                    }
                });
        },
        getReportcontent() {
            var that = this;

            that.$axios
                .post(
                    "word/words?token=" + sessionStorage.getItem("token"),
                    that.$qs.stringify({
                        ReportID: this.user.ReportID,
                    })
                )
                .then((res) => {
                    if (res.data.code == 10000) {
                        this.cgzbg1 = res.data.data;
                    }
                });
            that.$axios
                .post(
                    "reportcontent/info?token=" + sessionStorage.getItem("token"),
                    that.$qs.stringify({
                        ReportID: this.user.ReportID,
                        MouldID: this.user.MouldID,
                    })
                )
                .then((res) => {
                    if (res.data.code == 10000) {
                        console.log(res.data.data, "报告");
                        this.contentInfo = res.data.data;

                        this.yulan = JSON.stringify(this.contentInfo);
                        // console.log(this.yulan);
                        this.contentInfo.forEach((el) => {
                            if (el.Title == "cgzbg") {
                                this.cgzbg = el.Content;
                            }
                            if (el.Title == "fj1") {
                                this.fj = el.Content;
                            }
                        });
                    } else {
                        this.$message({
                            message: res.data.msg,
                            type: "warning",
                        });
                    }
                });
        },
        tabchange(a, b, c) {
            let that = this;
            this.lookStatus = "";
            this.yulan = "";
            if (c != 3) {
                this.tabClick = a;
            }
            if (b) {
                console.log(b);
                this.user = b;

                this.reviewform = b;

                if (that.reviewform.Status == 1) {
                    for (var key in that.reviewform) {
                        switch (key) {
                            case "score1":
                                !that.reviewform[key] ? (that.reviewform[key] = 0) : "";
                                break;
                            case "score2":
                                !that.reviewform[key] ? (that.reviewform[key] = 0) : "";
                                break;
                            case "score3":
                                !that.reviewform[key] ? (that.reviewform[key] = 0) : "";
                                break;
                            case "score4":
                                !that.reviewform[key] ? (that.reviewform[key] = 0) : "";
                                break;
                            case "score5":
                                !that.reviewform[key] ? (that.reviewform[key] = 0) : "";
                                break;
                            case "score6":
                                !that.reviewform[key] ? (that.reviewform[key] = 0) : "";
                                break;
                            case "score7":
                                !that.reviewform[key] ? (that.reviewform[key] = 0) : "";
                        }
                    }
                } else {
                    for (let i = 0; i < 20; i++) {
                        this.test.push(false);
                    }
                }
                this.getBaogao();
                // this.reportid = b.ID;
                this.getReportcontent(); //获取文件地址
                //this.getReview();
            }
            if (c) {
                this.lookStatus = c;
            }
            if (c == 2) {
                // window.frames["hrong"].location.href="http://view.xdocin.com/xdoc?_xdoc="+this.cgzbg;
                console.log(this.cgzbg, "主报告");
                // document.getElementById("aaa").src="http://view.xdocin.com/xdoc?_xdoc="+this.cgzbg;
            }
            if (c == 3) {
                if (this.fj) {
                    window.location.href = this.fj;
                } else {
                    this.$message({
                        message: "暂无附件信息",
                        type: "warning",
                    });
                }
            }
        },
        // dowCg(i) {
        //   if (i == 1) {
        //     console.log(this.sbb);
        //     // window.location.href = this.sbb;
        //   } else {
        //     console.log(this.zgzbg);
        //     // window.location.href = this.cgzbg1;
        //   }
        // },
        CurrentChange1(val) {
            // console.log(val);
            this.Page1 = val;
            this.getdata();
        },
        handleSizeChange1(val) {
            // console.log(val);
            this.PageSize1 = val;
            this.getdata();
        },
    },
    computed: {
        value1: function() {
            return (
                Number(this.reviewform.score1) +
                Number(this.reviewform.score2) +
                Number(this.reviewform.score3) +
                Number(this.reviewform.score4) +
                Number(this.reviewform.score5) +
                Number(this.reviewform.score6) +
                Number(this.reviewform.score7)
            );
        },
    },
    components: {
        Head,
        Foot,
        Nav,
        Preview,
        FullPreview,
        // CollapseTransition
    },
};
</script>
<style lang="less" scoped>
.time {
    position: relative;
    .time-select {
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
    }
}
.clear:after {
    /*伪元素是行内元素 正常浏览器清除浮动方法*/
    content: "";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
}
input:disabled,
textarea:disabled {
    border: 1px solid #ddd;
    background-color: #f5f5f5;
    color: #000;
}
.btn {
    width: 4.6rem;
    cursor: pointer;
    height: 0.58rem;
    line-height: 0.58rem;
    font-size: 0.17rem;
    text-align: center;
    background: #2d65d2;
    color: #fff;
}
.btnchange {
    background-color: #f2f2f4;
    color: #000000;
}
.btnmini {
    width: 1rem;
    height: 0.4rem;
    line-height: 0.4rem;
    border-radius: 0.05rem;
}
.hotspot {
    width: 100%;
    min-width: 1000px;
    font-size: 0.16rem;
    padding: 0.28rem 2.54rem;
    box-sizing: border-box;
    .standard {
        width: 11.5rem;
        min-width: 750px;
        padding-left: 0.2rem;
        height: 100%;
        float: right;
        border-left: 1px #eeeeee solid;
        padding-bottom: 0.3rem;
        .title {
            font-size: 0.18rem;
            margin-bottom: 0.1rem;
            display: flex;
            align-items: center;
            i {
                width: 0.3rem;
                height: 0.3rem;
                display: inline-block;
                background: url("../../assets/back/standard.png") no-repeat;
                margin-right: 0.1rem;
            }
        }
        .button {
            text-align: center;
        }
    }
    .H-right {
        position: relative;
        width: 11.5rem;
        min-width: 750px;
        padding-left: 0.2rem;
        height: 100%;
        float: right;
        min-height: 7.4rem;
        border-left: 1px #eeeeee solid;
        .left-button {
            display: flex;
            .lastBtn {
                margin-left: 0.6rem;
            }
        }
        .btnselect {
            display: flex;
        }
        .H-header {
            .t-left {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                height: 0.5rem;
                > span,
                select,
                div,
                input {
                    margin-right: 0.2rem;
                    width: 2rem;
                    height: 0.4rem;
                }

                input {
                    padding: 0.05rem;
                }
            }
            .t-right {
                float: right;
            }
        }
        .t_main {
            .t_main_select {
                select {
                    width: 2rem;
                    height: 0.4rem;
                    margin-bottom: 0.2rem;
                    margin-right: 0.2rem;
                }
            }
            .table {
                .list {
                    width: 100%;
                    // height: 2rem;
                    display: flex;
                    align-items: center;
                    position: relative;
                    border-bottom: 1px #d9d9d9 solid;
                    &:hover {
                        background: #f0f0f0;
                    }
                    .btn {
                        position: absolute;
                        top: 0.2rem;
                        right: 0.2rem;
                    }
                    .l-right {
                        width: 3.14rem;
                        height: 1.56rem;
                        position: relative;
                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }
                    .l-info {
                        flex: 1;
                        // padding-left: 0.3rem;
                        font-size: 0.16rem;
                        color: #4e4e4e;
                        height: 100%;
                        .l-info-name {
                            span {
                                font-size: 0.2rem;
                                font-weight: bold;
                                color: #171717;
                                line-height: 0.5rem;
                            }
                            i {
                                font-style: normal;
                                background: #ff0a0a;
                                color: #ffffff;
                                display: inline-block;
                                font-size: 0.14rem;
                                margin-left: 0.2rem;
                                height: 0.19rem;
                                text-align: center;
                                border-radius: 0.04rem;
                            }
                        }
                        .l-info-bottom {
                            width: 70%;
                            display: flex;
                            justify-content: space-between;
                            .l-info-text {
                                height: 0.5rem;
                                margin-bottom: 0.1rem;
                            }
                            .l-info-time {
                                margin-right: 0.2rem;
                                margin-bottom: 0.1rem;
                            }
                            .l-info-text {
                                span {
                                    float: left;
                                    font-weight: 800;
                                    margin-right: 0.2rem;
                                    line-height: 0.25rem;
                                }
                                div {
                                    margin-left: 0.4rem;
                                    line-height: 0.25rem;
                                    display: -webkit-box;
                                    -webkit-box-orient: vertical;
                                    -webkit-line-clamp: 3;
                                    overflow: hidden;
                                }
                            }
                        }
                    }
                }
            }
        }
        .info {
            padding: 0.3rem 0.3rem 0.1rem 0.3rem;
            border: 1px #d0d0d0 solid;
            .jieguo {
                font-size: 0.18rem;
                font-weight: bold;

                display: flex;
                align-items: center;
                .jieguospan {
                    color: #1c1c1c;
                    background: #fff;
                    margin-left: 0.05rem;
                    width: 0.8rem;
                }
                .repetition {
                    width: 1rem;
                    height: 0.4rem;
                    background: #ff0000;
                    border-radius: 0.04rem;
                    color: #fff;
                    font-size: 0.16rem;
                    margin: 0 0.2rem 0 0.52rem;
                    text-align: center;
                    line-height: 0.4rem;
                }
                // line-height: 100%;
                // height: .4rem;
                i {
                    display: inline-block;
                    width: 0.35rem;
                    height: 0.35rem;
                    background-image: url("../../assets/back/serach.png");
                    background-size: 80%;
                    background-repeat: no-repeat;
                    background-position: 100% 100%;
                    margin-right: 0.05rem;
                }
                span {
                    color: #d93838;

                    margin-right: 0.2rem;
                }
                a {
                    font-weight: 400;
                    text-decoration: underline;
                    cursor: pointer;
                }
            }
            > div {
                height: 0.7rem;
            }
            .span1 {
                margin-left: 0.4rem;
            }
            .span2 {
                margin-left: 0.7rem;
            }
            .span3 {
                margin-left: 0.85rem;
            }
            span {
                display: inline-block;
                color: white;
                width: 1rem;
                text-align: center;
                line-height: 0.5rem;
                height: 0.5rem;
                cursor: pointer;
                background: #2d65d2;
                border-radius: 0.1rem;
            }
            > div:nth-of-type(5) {
                display: flex;
                span {
                    display: inline-block;
                    width: 2.2rem;
                }
                div {
                    margin: 0;
                    margin-top: 0.1rem;
                }
            }
            > div {
                // margin:0.5rem 0 ;
                > div {
                    margin-left: 0.93rem;
                    line-height: 0.26rem;
                }
                > span {
                    // float: left;
                    line-height: 0.5rem;
                }
                .upload {
                    cursor: pointer;
                    width: 1rem;
                    padding-left: 0.3rem;
                    background: url(../../assets/back/18.png) left center no-repeat;
                }
            }
        }
        .title {
            .score {
                float: right;
                width: 1rem;
                margin-right: 50%;

                border: 0.01rem solid #999;
                height: 0.35rem;
                display: inline-block;
            }
            position: relative;
            margin: 0.5rem 0;
            font-size: 0.18rem;
            font-family: Microsoft YaHei;
            .warning {
                position: absolute;
                right: 4.5rem;
                top: 0.1rem;
                color: #f56c6c;
                font-size: 0.14rem;
                // margin-bottom: 5%;
            }
            > input {
                float: right;
                height: 0.35rem;
                margin-right: 50%;
                padding: 0.05rem;
            }
            > div {
                display: flex;
                height: 0.35rem;
                align-items: center;
                > div {
                    height: 0.05rem;
                    width: 0.05rem;
                    border-radius: 50%;
                    background: #2d65d2;
                    margin-right: 0.2rem;
                }
            }
        }
        .yijian {
            > div {
                display: flex;
                height: 0.35rem;
                align-items: center;
                > div {
                    height: 0.05rem;
                    width: 0.05rem;
                    border-radius: 50%;
                    background: #2d65d2;
                    margin-right: 0.2rem;
                }
            }
            textarea {
                position: relative;
                top: -0.35rem;
                left: 1.1rem;
                width: 80%;
            }
        }
        .sub {
            width: 100%;
            div {
                margin-left: 50%;
                transform: translate(-50%, 0);
            }
        }
    }
}
.Popup {
    width: 100%;
    position: absolute;
    top: 0;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    z-index: 1000;
    .none {
        width: 100%;
        height: 100%;
        position: relative;
    }
    .a_forms {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 7rem;
        height: 6rem;
        background: white;
        font-size: 0.16rem;
        .f-top {
            height: 0.5rem;
            width: 100%;
            text-align: center;
            line-height: 0.5rem;
            position: relative;
            border-bottom: 1px #cfcfcf solid;
            div {
                cursor: pointer;
                position: absolute;
                right: 0;
                top: 0;
                height: 0.5rem;
                width: 0.5rem;
                background: url("../../assets/back/x.png") center center no-repeat;
            }
        }
        .f-info {
            padding: 0.2rem 0.68rem 0;
            .p-info {
                > .p-input {
                    align-items: center;
                }
                > .upimg {
                    align-items: center;
                    justify-content: space-between;
                }
                > div {
                    margin: 0.2rem 0;
                    display: flex;
                    > .p-time {
                        position: relative;
                        flex: 1;
                        margin: 0 0.2rem;
                        > input {
                            width: 100%;
                            padding: 0.05rem;
                            height: 0.3rem;
                            border: 1px #cccccc solid;
                        }
                        .p-select {
                            width: 100%;
                            top: 0;
                            left: 0;
                            opacity: 0;
                            position: absolute;
                        }
                        .icon {
                            position: absolute;
                            top: 0;
                            right: 0;
                            height: 0.3rem;
                            width: 0.3rem;
                            background: url("../../assets/back/time.png") center center no-repeat;
                        }
                    }
                    > input {
                        flex: 1;
                        padding: 0.05rem;
                        margin: 0 0.2rem;
                        height: 0.3rem;
                        border: 1px #cccccc solid;
                    }
                    > textarea {
                        flex: 1;
                        padding: 0.05rem;
                        margin: 0 0.2rem;
                        border: 1px #cccccc solid;
                    }
                    i {
                        font-style: normal;
                        color: #ff0d0d;
                    }
                }
            }
            .f-bottom {
                display: flex;
                justify-content: space-around;
                align-items: center;
            }
        }
    }
}
</style>
